export const ATTRIBUTE_MODELS = [
  { id: 0, key: 'CONVERSATION' },
  { id: 1, key: 'CONTACT' },
];

export const ATTRIBUTE_TYPES = [
  { id: 0, key: 'TEXT' },
  { id: 1, key: 'NUMBER' },
  { id: 4, key: 'LINK' },
  { id: 5, key: 'DATE' },
  { id: 6, key: 'LIST' },
  { id: 7, key: 'CHECKBOX' },
];
export const getAttributeLabel = (t, group, key) => {
  if (group === 'models') {
    switch (key) {
      case 'CONVERSATION':
        return t('ATTRIBUTES_MGMT.ATTRIBUTE_MODELS.CONVERSATION');
      case 'CONTACT':
        return t('ATTRIBUTES_MGMT.ATTRIBUTE_MODELS.CONTACT');
      default:
        return '';
    }
  }

  switch (key) {
    case 'TEXT':
      return t('ATTRIBUTES_MGMT.ATTRIBUTE_TYPES.TEXT');
    case 'NUMBER':
      return t('ATTRIBUTES_MGMT.ATTRIBUTE_TYPES.NUMBER');
    case 'LINK':
      return t('ATTRIBUTES_MGMT.ATTRIBUTE_TYPES.LINK');
    case 'DATE':
      return t('ATTRIBUTES_MGMT.ATTRIBUTE_TYPES.DATE');
    case 'LIST':
      return t('ATTRIBUTES_MGMT.ATTRIBUTE_TYPES.LIST');
    case 'CHECKBOX':
      return t('ATTRIBUTES_MGMT.ATTRIBUTE_TYPES.CHECKBOX');
    default:
      return '';
  }
};
